// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__oNe3g","icon":"styles_icon__y7HBQ","sign":"styles_sign__G_74V","execute":"styles_execute__YeVrC"};